import doc                  from 'decorators/doc';
import model                from 'decorators/model';
import SalesPrivateApiModel from '../../abstracts/SalesPrivateApiModel';

@model.staticLabel('OptionType')
@model.urnResource('option_type')
@doc.path('/option_types/{?id}')
export default class OptionTypeModel extends SalesPrivateApiModel {

	@doc.string declare label: string;
	@doc.string declare reference: SalesOptionTypeReference;
}
